import api from './api';

export const authService = {
  login: async (username, password) => {
    try {
      const response = await api.post('/auth/login', {
        username,
        password,
      });

      const { access_token } = response.data;

      if (!access_token) {
        throw new Error('A resposta do login não retornou access_token.');
      }

      localStorage.setItem('token', access_token);

      return access_token;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('active_tenant_id');
    localStorage.removeItem('active_tenant_name');
    localStorage.removeItem('active_tenant_slug');
  },

  getMe: async () => {
    try {
      const response = await api.get('/auth/me');
      const user = response.data;

      localStorage.setItem('user', JSON.stringify(user));

      return user;
    } catch (error) {
      console.error('GetMe error:', error);
      throw error;
    }
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
};
